import React from 'react'

import LandingPageContainer from './LandingPageContainer.jsx'

import ActivitiesProgressReport from '../components/progress_reports/activities_progress_report.tsx'
import ActivitiesScoresByClassroomProgressReport from '../components/progress_reports/activities_scores_by_classroom_progress_report.jsx'
import StudentOverview from '../components/progress_reports/student_overview.jsx'
import PremiumBannerBuilder from '../components/scorebook/premium_banners/premium_banner_builder'

export default class ProgressReportIndex extends React.Component {

  renderContent = () => {
    const { currentUser, premiumStatus, classrooms, } = this.props

    const path = window.location.pathname;
    const shouldHavePremiumBanner = !['landing_page', 'diagnostic_report', 'social-studies', 'interdisciplinary-science', 'quill-for-texas', 'literature', 'diagnostic_insights', 'skills_report', 'standards_report', 'live_view'].find(slug => path.includes(slug));

    const props = {
      sourceUrl: `${path}.json`,
      premiumStatus,
      currentUser,
      classrooms
    };

    const progressReportMapping = {
      'progress-reports-activities': <ActivitiesProgressReport {...props} />,
      'progress-reports-landing-page-container': <LandingPageContainer {...props} />,
      'progress-reports-activities-scores-by-classroom': <ActivitiesScoresByClassroomProgressReport {...props} />,
      'progress-reports-student-overview': <StudentOverview {...props} />,
    };

    let component

    Object.keys(progressReportMapping).forEach(className => {
      const el = document.getElementsByClassName(className)[0]
      if (el) {
        component = progressReportMapping[className]
      }
    });

    const containerStyle = component ? 'gray-background-accommodate-footer container' : ''

    return (
      <React.Fragment>
        {shouldHavePremiumBanner && <PremiumBannerBuilder originPage="report" />}
        <div className={containerStyle}>
          {component}
        </div>
      </React.Fragment>
    )
  };


  render() {
    return this.renderContent()
  }
}
